import HttpClient from './http.client'

export default class ExternalService {

    static show_client = async (id: any) : Promise<any> => {
        return HttpClient.get(`/external/clients/${id}`)
    }
}
